/**
 * joy space 分享文档, 文件入品
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React from "react";
import { JoySpaceDocumentMessage, Session, SessionType } from "@/types/chat";
import { MessageSendType } from "@/types/chat/enum";
import { WithTranslation } from "react-i18next";
import ShareJdoc from "@/components/chat/message/share/Jdoc";
import UnSupport from "@/components/chat/message/UnSupport";
import CommonCard from "./CommonCard";
import MeetingCard from "./MeetingCard";
import DefaultCommonCard from "./DefaultCommonCard";
import ShareUserCard from "@/components/chat/message/share/UserCard";
import ShareUserCardList from "@/components/chat/message/share/UserCardList";
import ShareAppCardList from "@/components/chat/message/share/AppCardList";
import ShareJoyspaceCardList from "@/components/chat/message/share/JoyspaceCardList";
import ShareHintCardList from "@/baseComponents/Chat/AIHintCardList";
import MergeForward from "@/components/chat/message/share/MergeForward";
import Text from "@/components/chat/message/Text";
import FileLinkCard from "@/components/chat/message/share/FileLinkCard";
import CommSummaryCard from "@/components/chat/message/share/CommSummaryCard";
import MeetingScheduleCard from "./MeetingScheduleCard";
import WorkSummaryCard from "./WorkSummaryCard";
import MultiImageTextCard from "./MultiImageTextCard";
import ChatState from "@/types/chat/State";
import { connect } from "dvajs";
import ImageTextCardLink from "./MultiImageTextCard/ImageTextCardLink";
import ImagesCard from "./ImagesCard";

interface ShareProps {
  message: JoySpaceDocumentMessage;
  sessionType: SessionType;
  sendType: MessageSendType;
  onReady: (params: { beginSend: boolean; messageExtend: any }) => {};
  selectedSession: Session;
  // count: number;
}

type IShareProps = Readonly<ShareProps>;

function Share(props: IShareProps) {
  const { message, selectedSession } = props;
  const sharelink =
    message.data && message.data[0] ? message.data[0].sharelink : { category: "", url: "" };
  const { template } = message;
  // 数据兼容
  if (!template) {
    return <UnSupport message={message} />;
  }
  if (template?.nativeId === "merge_forward") {
    // if (typeof count === 'undefined' || (typeof count === 'number' && count < 2)) {
    return <MergeForward {...props} />;
    // } else {
    //     return <UnSupport message={message} />;
    // }
  }
  // template: {nativeId: "share_link"}  merge_forward
  if (template?.nativeId === "share_link") {
    if (sharelink?.category === "jd_doc") {
      return <ShareJdoc {...props} />;
    } else {
      return <CommonCard {...props} />;
    }
  } else if (template?.nativeId === "share_card") {
    // 用户卡片
    return <ShareUserCard {...props} />;
  } else if (template?.nativeId === "share_card_multi") {
    // 用户卡片
    return <ShareUserCardList {...props} />;
  } else if (template?.nativeId === "share_app_multi") {
    // 应用卡片
    return <ShareAppCardList {...props} />;
  } else if (template?.nativeId === "share_document_search") {
    // 文档卡片
    return <ShareJoyspaceCardList {...props} />;
  } else if (template?.nativeId === "share_hint_multi") {
    // 提示词卡片
    return <ShareHintCardList {...props} />;
  } else if (template?.nativeId === "share_meeting_schedule") {
    // 日程&会议
    return <MeetingScheduleCard {...props} />;
  } else if (template?.nativeId === "share_file_link") {
    // 文件摘要发送卡片
    return <FileLinkCard {...props} />;
  } else if (template?.nativeId === "share_comm_summary") {
    // 摘要回复卡片
    return <CommSummaryCard {...props} />;
  } else if (template?.nativeId === "share_work_summary") {
    // 工作总结回复卡片
    return <WorkSummaryCard {...props} />;
  } else if (template?.nativeId === "share_images_card") {
    // 图片卡片
    return <ImagesCard {...props} />;
  } else if (template?.nativeId === "voip_hint") {
    // 语音电话
    const _message = { ...props.message, content: (props.message as any).text };
    const _props = { ...props, message: _message };
    return <Text {..._props} />;
  } else if (template?.nativeId === "note_share") {
    return <MeetingCard {...props} />;
  } else if (template?.nativeId === "meetinglive_pull") {
    return <MeetingCard {...props} />;
  } else if (template?.nativeId === "share_multi_image_txt") {
    // 多图文
    if (selectedSession.isOrgBroadcast || selectedSession.isOrgNormal) {
      return <MultiImageTextCard {...props} />;
    } else {
      return <ImageTextCardLink {...props} />;
    }
  } else if (template?.nativeId === "common_card") {
    return <DefaultCommonCard {...props} />;
  } else {
    return <UnSupport message={message} />;
  }
}

function mapStateToProps({ chat }: { chat: ChatState }) {
  const { selectedSession } = chat;
  return {
    selectedSession
  };
}

function mapDispatchToProps(dispatch: any) {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(Share);
